import { USER_STORAGE_KEY } from "../utils/constants";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const useInactivity = (enabled: boolean) => {
  const navigate = useNavigate();
  const timeoutRef = useRef<number | null>(null);

  const logout = () => {
    localStorage.removeItem(USER_STORAGE_KEY);
    navigate("/", { replace: true });
  };

  const resetTimer = () => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      logout();
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    if (!enabled) {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
      return;
    }
    const events: (keyof WindowEventMap)[] = [
      "mousemove",
      "keydown",
      "mousedown",
      "scroll",
      "touchstart",
    ];
    const handleActivity = () => {
      resetTimer();
    };

    // set initial timer
    resetTimer();

    // add event listeners
    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
};
